import { render, staticRenderFns } from "./CommunicationViewAttachements.vue?vue&type=template&id=dfe4c632&scoped=true"
import script from "./CommunicationViewAttachements.vue?vue&type=script&lang=js"
export * from "./CommunicationViewAttachements.vue?vue&type=script&lang=js"
import style0 from "./CommunicationViewAttachements.vue?vue&type=style&index=0&id=dfe4c632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4c632",
  null
  
)

export default component.exports